import classNames from 'classnames'
import Lottie from 'lottie-react'

import type { ReactElement } from 'react'

import mwmLoader from '~/assets/lotties/mwm-loader.json'

import './styles.scss'

export interface Props {
  category: 'general' | 'item'
  className?: string
}

const MwMLoader = ({ category, className }: Props): ReactElement => {
  return (
    <div aria-label="Loading" aria-live="polite" className={classNames('loader-component', className)} role="status">
      <Lottie animationData={mwmLoader} style={{ height: category === 'general' ? '10rem' : '5rem' }} />
    </div>
  )
}

export default MwMLoader
